<template>
  <div style="width:100%;">
    <v-row dense>
      <v-divider></v-divider>
    </v-row>
    <v-row dense class="mt-2" justify="center" align="center">
      <v-col cols="auto">
        <v-text-field
          type="number"
          label="Rows"
          v-model.number="rowsCount"
          min="0"
          dense
          outlined
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-text-field
          type="number"
          label="Columns"
          v-model.number="colsCount"
          min="0"
          dense
          outlined
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row dense class="mt-2">
      <v-divider></v-divider>
    </v-row>
    <v-simple-table class="mt-2">
      <tbody>
        <tr v-for="(row, rowIndex) in internalModel" :key="'row-' + rowIndex">
          <td v-for="(cell, colIndex) in row" :key="'cell-' + rowIndex + '-' + colIndex">
            <v-text-field
              v-model="internalModel[rowIndex][colIndex]"
              @input="updateModel(rowIndex, colIndex, internalModel[rowIndex][colIndex])"
              dense
              outlined
              hide-details
            ></v-text-field>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
  name: "r-level-track-level-field-tiles-view",
  props: {
    model: VueTypes.arrayOf(VueTypes.arrayOf(VueTypes.String))
  },
  data() {
    return {
      internalModel: [],
      rowsCount: 0,
      colsCount: 0
    };
  },
  computed: {
    value: {
      get() {
        if (!this.model || !Array.isArray(this.model)) {
          return [];
        }
        return this.model;
      },
      set(val) {
        this.$emit("update:model", val);
      }
    },
    maxColumns() {
      let max = 0;
      this.internalModel.forEach(row => {
        if (row.length > max) {
          max = row.length;
        }
      });
      return Array.from({ length: max });
    }
  },
  watch: {
    model: {
      immediate: true,
      handler(newVal) {
        // Sync internal state with the prop
        if (Array.isArray(newVal)) {
          this.internalModel = newVal.map(row => row.slice());
        } else {
          this.internalModel = [];
        }
        // Set initial row/col counts
        this.rowsCount = this.internalModel.length;
        this.colsCount = this.internalModel.length > 0 ? this.internalModel[0].length : 0;
      }
    },
    rowsCount(newVal) {
      this.resizeMatrix(newVal, this.colsCount);
    },
    colsCount(newVal) {
      this.resizeMatrix(this.rowsCount, newVal);
    }
  },
  methods: {
    updateModel(rowIndex, colIndex, value) {
      this.internalModel[rowIndex][colIndex] = value;
      this.value = this.internalModel;
    },
    resizeMatrix(newRows, newCols) {
      // Adjust the number of rows
      if (newRows < this.internalModel.length) {
        // Slice off extra rows
        this.internalModel.splice(newRows);
      } else if (newRows > this.internalModel.length) {
        // Add new rows
        const cols = this.internalModel.length > 0 ? this.internalModel[0].length : newCols;
        for (let i = this.internalModel.length; i < newRows; i++) {
          this.internalModel.push(Array(cols).fill(""));
        }
      }

      // Adjust the number of columns in each row
      this.internalModel.forEach(row => {
        if (newCols < row.length) {
          row.splice(newCols);
        } else if (newCols > row.length) {
          while (row.length < newCols) {
            row.push("");
          }
        }
      });

      this.value = this.internalModel;
    }
  }
};
</script>
